import GuidanceRegistry from '../guidance-registry.js';

GuidanceRegistry.register({
    type: "action-item-ewf-guided-setup-calendar-review",
    prompt: (guidanceItem) => getPrompt(guidanceItem),
    briefDescription: 'Calendar Review',
    openAction: {
        text: "Where to review payroll calendar(s)?",
        url: (guidanceItem) => getOpenUrl(guidanceItem)
    },
    completeAction: {
    },
});

function getOpenUrl(guidanceItem) {
    let url = `/employer/${guidanceItem.employerId}/calendars`;
    if (guidanceItem.parameters && guidanceItem.parameters.orderEffectiveDate && guidanceItem.parameters.calendarId) {
        let date = moment(guidanceItem.parameters.orderEffectiveDate).format('MM-DD-YYYY');
        url = url.concat(`?orderEffectiveDate=${date}&calendarId=${guidanceItem.parameters.calendarId}`);
    } 

    return url;
}

function getPrompt(guidanceItem) {
    if (guidanceItem.parameters && guidanceItem.parameters.calendarsNeedingReview) {
        let calendarNames = guidanceItem.parameters.calendarsNeedingReview;
        calendarNames = calendarNames.length > 1 
                            ? calendarNames.slice(0, -1).join(', ') + ' and ' + calendarNames.slice(-1)
                            : calendarNames[0];

        return `See the warning generated below for ${calendarNames}. Then review your payroll calendars for each applicable plan to ensure the correct number of deductions have been selected. To make any changes, click Edit, then click on any deductions that should be removed.`;
    }

    return null;
}



// WEBPACK FOOTER //
// ./src/guidance/items/guidance-calendar-review.js